const LOCAL_STORAGE_PREFIXES = ["nxstart_", "nxSurvey"];
const LOCAL_STORAGE_KEYS = [
  "accessToken",
  "user",
  "refreshTokenExpiresAt",
  "app_logout_signal",
];
const SESSION_STORAGE_PREFIXES = ["nxstart."];

const collectKeysToRemove = (storage, prefixes = [], exactKeys = []) => {
  if (!storage) return [];
  const exact = new Set(exactKeys);
  const keys = [];

  for (let i = 0; i < storage.length; i += 1) {
    const key = storage.key(i);
    if (!key) continue;

    if (exact.has(key) || prefixes.some((prefix) => key.startsWith(prefix))) {
      keys.push(key);
    }
  }

  return keys;
};

const removeKeys = (storage, keys = []) => {
  if (!storage) return;
  keys.forEach((key) => {
    try {
      storage.removeItem(key);
    } catch {
      // Ignore storage remove failures.
    }
  });
};

const clearPersistedState = () => {
  if (typeof window === "undefined") return;

  removeKeys(
    window.localStorage,
    collectKeysToRemove(
      window.localStorage,
      LOCAL_STORAGE_PREFIXES,
      LOCAL_STORAGE_KEYS,
    ),
  );

  removeKeys(
    window.sessionStorage,
    collectKeysToRemove(window.sessionStorage, SESSION_STORAGE_PREFIXES),
  );
};

export const cleanupAppStateAfterLogout = async () => {
  clearPersistedState();
};
